export default "__VITE_ASSET__w1jh8amB__"